import { css, cx, useTheme } from '@fable/theme'
import errorIcon from '../../assets/icons/standard/error-icon.svg'
import { FlexBox, Text } from '@fable/components'
import { useTypedSelector } from '../../hooks'

const ErrorBanner: React.VFC<
  {
    fixed?: boolean
    fullWidth?: boolean
  } & React.HTMLAttributes<HTMLDivElement>
> = ({ fixed = false, fullWidth = false, ...nativeProps }) => {
  const { errorBannerMessage } = useTypedSelector(
    ({ errorBanner }) => errorBanner
  )
  const { colors, motion, mediaQueries } = useTheme()

  const styles = {
    errorMessageBannerContainer: css`
      margin: -60px 24px 24px 24px;
      opacity: 0;
      max-width: none;
      ${motion.transition()};
    `,
    fixed: css`
      z-index: 99999;
      width: 100vw;
      position: fixed;
      left: -30px;
      transform: translateY(-60px);
    `,
    errorMessageBanner: css`
      background: ${colors.mahogany};
      border-radius: ${fullWidth ? 0 : 8}px;
      padding: 12px 14px;
      max-width: ${fullWidth ? 'none' : '80%'};
      width: ${fullWidth ? '100%' : 'auto'};
      ${mediaQueries.mobileL} {
        border-radius: 8px;
        max-width: ${fullWidth ? 'none' : 'fit-content'};
      }
    `,
    pushDown: css`
      margin-top: 0px;
      opacity: 1;
    `,
    slideDown: css`
      transform: translateY(90px);
      opacity: 1;
    `,
    errorMessage: css`
      line-height: 16px;
      color: ${colors.whiteFang};
      margin-left: 12px;
    `,
  }

  const animateInClass = () => {
    if (errorBannerMessage?.length > 0) {
      if (fixed) return styles.slideDown
      return styles.pushDown
    }
    return ''
  }

  return (
    <FlexBox
      {...nativeProps}
      className={cx(
        styles.errorMessageBannerContainer,
        fixed ? styles.fixed : '',
        animateInClass(),
        nativeProps.className
      )}
      centerAll
    >
      <FlexBox className={styles.errorMessageBanner} alignItems="center">
        <img src={errorIcon} alt="Error Icon" />
        <Text
          className={styles.errorMessage}
          data-testid="errorBanner"
          type="body"
          sizing={{ base: 'M', mobileL: 'L' }}
        >
          {errorBannerMessage}
        </Text>
      </FlexBox>
    </FlexBox>
  )
}

export default ErrorBanner
